/* eslint no-loop-func: 0 */
import $ from 'jquery';
import Handlebars from 'handlebars';
import zipTools from 'components/zip-tools';
import responsive from 'lib/responsive';
import googleMaps from 'googlemaps';
import mapStyles from 'lib/mapStyles';
import txtTemplateInfoWindow from 'features/dealers/dealer.infowindow.hbs';
import bat from 'components/bat'; // bat.hcompile
import 'lib/helpers/toJSON';

var __google;
var __tmplInfoWindow = Handlebars.compile(txtTemplateInfoWindow);

var Maps = function Maps(args) {
  this.kind = args.kind; // map, imageMap, multimarker, directionsMap
  this.mapOptions = args.mapOptions;
  this.mapElement = args.mapElement;
  this.markers = args.markers;
  this.dealerData = args.dealerData;
  this.imgWidth = args.imgWidth;
  this.imgHeight = args.imgHeight;
  this.numberedMarkers = args.numberedMarkers;
  this.useFuelStyle = args.useFuelStyle; // BAT25-99
  this.google = __google;
  if (args.$form) {
    this.$form = args.$form;
  }
  this.init();
};

Maps.markerPath = 'http://www.buyatoyota.com/assets/img/maps/';

Maps.prototype = {
  init: function () {
    var self = this;
    switch (self.kind) {
      case 'map':
        self.initMap();
        break;
      case 'static':
        self.initImageMap();
        break;
      case 'multimarker':
        self.initMultimarker();
        break;
      case 'direction':
        self.initDirections();
        break;
      default:
        self.initMap();
    }
  }, // end init

  // Default: Map Mode
  initMap: function () {},

  // Default: Image Map Mode
  initImageMap: function () {
    var self = this;
    var getMapUrl = function () {
      var envApiKey = "AIzaSyDs2iYTroHjB8l7zbfHyWUec2cpESSIVK8";
      if (location.hostname !== "www.buyatoyota.com") {
        envApiKey = "AIzaSyDFiAZqwtWPEoQMCrtjkO1PiYZtRPqlJW0";
      }
      console.log(location.hostname + " googleApiKey: " + envApiKey);
      if (self.markers) {
        var markers = [];
        var reachedMax = false;
        var markersString = "";
        for (var i = 0; i < self.markers.length; i++) {
          if (!reachedMax) {
            if (self.numberedMarkers) {
              markers.push('&markers=shadow:false|icon:' + Maps.markerPath + 'marker-' + (i + 1) + '.png|' + self.markers[i].lat + ',' + self.markers[i].lon);
            } else {
              markers.push('&markers=shadow:false|icon:' + Maps.markerPath + 'marker.png|' + self.markers[i].lat + ',' + self.markers[i].lon);
            }
            markersString = markers.join('');
            if (markersString.length >= 1900) {
              markers.pop();
              markersString = markers.join('');
              reachedMax = true;
            }
          }
        }
        return encodeURI('//maps.googleapis.com/maps/api/staticmap?size=' + self.imgWidth + 'x' + self.imgHeight + '&maptype=roadmap' + markersString + '&key=' + envApiKey);
      }
      return encodeURI('//maps.googleapis.com/maps/api/staticmap?size=' + self.imgWidth + 'x' + self.imgHeight + '&key=' + envApiKey);
    };
    self.mapElement.src = getMapUrl();
  },

  // BAT-3486
  showActiveMarker: function (index) {
    var self = this;
    if(self.lastActiveMarker) {
      var defaultIcon = self.lastActiveMarker.defaultIcon;
        var labelPoint = self.lastActiveMarker.labelPoint;
      self.lastActiveMarker .setIcon({'url': defaultIcon, scaledSize: new __google.maps.Size(33, 43), labelOrigin:labelPoint});
      self.lastActiveMarker = null;
    }

    var activeIcon = this.allMapMarkers[index].activeIcon;
    if (activeIcon !== '') { //ONLY OPEN STATIONS HAVE AN ACTIVE ICON.
        var labelPoint = this.allMapMarkers[index].labelPoint;
      this.allMapMarkers[index].setIcon({'url': activeIcon, scaledSize: new __google.maps.Size(33, 43), labelOrigin:labelPoint});
      self.lastActiveMarker = this.allMapMarkers[index];
    }
  },

  selectMarker: function (index, ignoreCenter, ignoreTrigger) {
    var self = this;
    if(ignoreTrigger) {
      self.ignoreTrigger = true;
    }
    __google.maps.event.trigger(this.allMapMarkers[index], 'click');
    if(!ignoreCenter){
      var userCoords = new __google.maps.LatLng( this.allMapMarkers[index].position.lat(), this.allMapMarkers[index].position.lng());
      self.map.setCenter( userCoords );
    }
  },

  // BAT25-139
  displayLocation: function (position) {
    var self = this;
    var userCoords = new __google.maps.LatLng(position.lat, position.lon);

    // CREATE MARKER
    if (!self.userLocation) {
      // CUSTOM MAKER IMAGE.
      var image = new __google.maps.MarkerImage(
        '/assets/img/maps/user-location-dot.png',
        null, // size
        null, // origin
        new __google.maps.Point(8, 8), // anchor (move to center of marker)
        new __google.maps.Size(17, 17) // scaled size (required for Retina display icon)
      );

      // NEW MARKER.
      self.userLocation = new __google.maps.Marker({
        flat: true,
        icon: image,
        map: self.map,
        optimized: false,
        position: userCoords,
        title: 'You are here.', //used in css, not actually displayed.
        visible: true
      });
    } else {
      // POSITION AND SHOW MARKER.
      self.userLocation.setPosition( userCoords );
    }
    self.userLocation.setPosition( userCoords );
    // IF WE WANT TO CENTER ON LOCATION.
    self.map.setCenter( userCoords );
  },

  // MultiMarker Mode
  initMultimarker: function () {
    var self = this;
    var i;
    var marker;
    var markerIcon;
    var infowindow = new __google.maps.InfoWindow({});
    var showMapUI = responsive() === 'sm';

    var zoomVar = 9;
    if (self.markers.length < 2) {
      zoomVar = 12;
    }
    // BAT25-99
    var useStyle;
    if (self.useFuelStyle) { // BAT25-99
      showMapUI = true;
    }

    self.map = new __google.maps.Map(self.mapElement, {
      zoom: zoomVar,
      center: new __google.maps.LatLng(self.markers[0].lat, self.markers[0].lon),
      mapTypeId: __google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: showMapUI,
      mapTypeControl: false,
      fullscreenControl: false,
      streetViewControl: false,
      zoomControl: true,
    });

    self.map.mapTypes.set('styled_map', new __google.maps.StyledMapType(mapStyles.default));
    self.map.setMapTypeId('styled_map');

    __google.maps.event.addListener(self.map, 'click', function () {
      if (infowindow) {
        infowindow.close();
      }
    });

    self.allMapMarkers = [];
    self.infowindow = infowindow;

    // Center the map around the bounds of the markers
    var latlngbounds = new __google.maps.LatLngBounds();

    for (var j = 0; j < self.markers.length; j += 1) {
      latlngbounds.extend(new __google.maps.LatLng(self.markers[j].lat, self.markers[j].lon));
    }

    if (self.markers.length > 1) {
      self.map.fitBounds(latlngbounds);
    }
    self.latlngbounds = latlngbounds;
    // BAT-3486: markers now use generic background images and set label dynamcially for FuelStation maps.
    for (i = 0; i < self.markers.length; i += 1) {
      var markerName = self.useFuelStyle ? 'marker-blue-bg' : 'marker-'; // BAT-3486
      if (self.useFuelStyle && self.markers[i].closed) {
        // BAT-3486: CLOSED FuelStations GET GREY MARKER PIN.
        markerName = 'marker-grey-bg';
      }

      // BAT-3486
      var activeIcon = '';
      if (self.useFuelStyle && !self.markers[i].closed) {
        // BAT-3486: SELECTED OR ACTIVE MARKE PIN:
        activeIcon = '/assets/img/maps/marker-active-bg@2x.png';
      }

      if (self.numberedMarkers) { // BAT25-99 ONLY NUMBERED MARKERS USED IN MIRAI FUEL STATIONS MAP.
        markerIcon = '/assets/img/maps/' + markerName + (i + 1) + '.png';
        // default to 2X MAKER FOR RETINA
        if (self.useFuelStyle) {
          // BAT-3486: FuelStation MARKERS PINS ARE DYNAMIC, ONLY BG IS USED, NUMBER IS SET BY LABEL.
          markerIcon = '/assets/img/maps/' + markerName + '@2x.png';
        }
      } else {
        markerIcon = '/assets/img/maps/marker.png';
      }
      var image = { url: markerIcon };
      var closed = false;
      var label = { text: '' };
      // CORRECT THE SIZE FOR THE MARKER.
      if (self.useFuelStyle) {
        var labelPoint =  new __google.maps.Point(15, 14);
        image = {
          url: markerIcon,
          labelOrigin: labelPoint
        };
        image.size = new __google.maps.Size(33, 43);
        // for the setting of the scaled size of the retina marker
        image.scaledSize = new __google.maps.Size(33, 43);
        if (self.markers[i].closed) {
          closed = true;
        }

        var labelstr = (i + 1).toString();
        label = {
          text: labelstr, color: '#fff', fontWeight: '600', fontSize: '14px'
        };

        /*
          BAT-3486 FUEL STATIONS GET SOME SPECIAL TREATMENT AND MARKERS WITH STATIC IMAGE AND DYNAMIC LABELS,
          ALSO SOME OTHER ITEMS FOR SELECTING ACTIVE STATION.
        */
        marker = new __google.maps.Marker({
          position: new __google.maps.LatLng(self.markers[i].lat, self.markers[i].lon),
          map: self.map,
          icon: image,
          labelClass: 'aa-link',
          activeIcon: activeIcon,
          defaultIcon: markerIcon,
          closed: closed,
          label: label,
          labelPoint: labelPoint // STORE FORE LATER USE
        });
      } else {
        marker = new __google.maps.Marker({
          position: new __google.maps.LatLng(self.markers[i].lat, self.markers[i].lon),
          map: self.map,
          icon: image,
          labelClass: 'aa-link'
        });
      }
      self.allMapMarkers.push(marker);
      // get single dealer data for handlebars
      var dealer = [];
      dealer[0] = self.dealerData[i];

      __google.maps.event.addListener(marker, 'click', (function (marker, i) {
        var resultHandlebar;
        if (self.useFuelStyle) { // BAT25-99
          var resultTemplate = $('#fuel-station-info').html();
          resultHandlebar = bat.hcompile(resultTemplate, {
            result: dealer
          });
          marker.addListener('click', function () {
            // fuelStations.resultItemClick is used to ascertain who is clicking, pin head or result item. pin head fires the DL.CLICK because there is no datalayer-link.
            self.ignoreTrigger = false; // this is only used for initial selected items, get passed in selectMarker ( in fuelStations )
            window.fuelStationsLocationsSetItemSelected(i);
          });
        // Default infowindows
        } else {
          resultHandlebar = __tmplInfoWindow(dealer);
        }

        return function () {
          var $infoWindowResult;
          infowindow.setContent(resultHandlebar);
          if (!fuelStations) { // BAT-3187. fuelStation is created in mirai-fuel-stations.js, if it doesn't exist, create obj to prevent errors.
            var fuelStations = {};
          }
          self.InfoWindowIndex = i;
          infowindow.open(self.map, marker);
          // BAT-2815 put this marker in global namespace so it can be opened again from outside of this click event
          // no.
          bat.batMapMarker = marker;

          if (fuelStations.resultItemClick) {
            fuelStations.resultItemClick = false; // RESET THE VALUE.
          }
          /*-----------------------------------------------------------------------------------------------------------------
          DL-32: Upon further investigation, the wrong selector is in use on the live site
          (#map-canvas instead of #map-canvas-dealer-search).
          Also, the pre-DL-32 Maps.js contained uncommented window.bat.omni.fire's (still on live site as well)
          see commit: https://repo.digiscloud.com/buyatoyota/BAT_ui/commit/914149f07443372adaba1e0e8fcee131b8bdc1d8
          Presumably these were left in place because planb.js click events on these 'Visit Dealer Website' links are
          NOT being attached (even when switched to use correct #map-canvas-dealer-search selector).
          -------------------------------------------------------------------------------------------------------------------*/
          $infoWindowResult = $(self.mapElement);
          // ensure links to different TDA get a warning message
          $infoWindowResult.find('a[data-tda-code]').on('click', zipTools.warnOnTDAChange);
          $infoWindowResult.find('a.js-maps').on('click', function () {
            // if this is our mobile only "view in maps" links, handle differently :(
            var address = '';
            if ($(this).parent().parent().hasClass('visible-sm')) {
              address = $(this).closest('.js-result-parent').find('a.js-maps').html().split('<span class="overlay-proximity">')[0];
            } else {
              address = $(this).html().split('<span class="overlay-proximity">')[0];
            }
            address = address.replace(',', '');// example: "1605 VFW ParkwayBoston, MA 02132"
            var urlfa = address.replace(/ /g, '+');
            var mapurl = 'https://maps.google.com/?daddr=' + urlfa;
            $(this).attr('href', mapurl);
          });
        };
      })(marker, i));
    }
  }, // END initMultimarker

  initDirections: function () {
    var self = this;
    if (self.mapElement) {
      var latitudeForDealer = self.mapElement.getAttribute('data-lat');
      var longitudeForDealer = self.mapElement.getAttribute('data-lng');
      var mapCenter = new __google.maps.LatLng(latitudeForDealer, longitudeForDealer);
      self.mapOptions.center = mapCenter;
      self.map = new __google.maps.Map(self.mapElement, self.mapOptions);
      self.map.mapTypes.set('styled_map', new __google.maps.StyledMapType(mapStyles.default));
      self.map.setMapTypeId('styled_map');

      var marker = new __google.maps.Marker({
        position: mapCenter,
        map: self.map,
        animation: __google.maps.Animation.DROP,
        icon: '/assets/img/maps/marker.png'
      });
      __google.maps.event.trigger(self.map, 'resize');
    }
  },
};

// needs to return a promise obj.
// on its resolve, return Maps.
export default function buildMap() {
  return googleMaps()
    .then(function (google) {
      __google = google;
      return Maps;
    })
    .catch(function (err) { console.warn('err in maps: ', err); }); // eslint-disable-line no-console
}
